import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { getRomarianInfoList, setAdmDataManagementError } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { useEffect, useState } from "react";

function RomarianDbInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { hagueRomarianInfo, madridRomarianInfo } = useSelector(state => ({
    hagueRomarianInfo: state.admDataManagement.hagueRomarianInfo,
    madridRomarianInfo: state.admDataManagement.madridRomarianInfo,
  }))

  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [noticeStr, setNoticeStr] = useState("");

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "1 months",
      fromDate: "",
      toDate: "",
      ftp: "Madrid"
    },

    onSubmit: (values) => {
      console.log(values.ftp)

      setData([])

      if (!values.fromDate || !values.toDate) {
        dispatch(setAdmDataManagementError("From date and to date are required!"))
        return
      }

      if (values.ftp === "Madrid") {
        if (!madridRomarianInfo || madridRomarianInfo?.length == 0) {
          console.log("Get all data madrid")
          dispatch(getRomarianInfoList({ romarianFtpType: "Madrid" }))
          return;
        } else {
          console.log("filter exist data madrid")
          filterData(madridRomarianInfo)
        }
      } else {
        if (!hagueRomarianInfo || hagueRomarianInfo?.length == 0) {
          console.log("Get all data hague")
          dispatch(getRomarianInfoList({ romarianFtpType: "Hague" }))
          return;
        } else {
          filterData(hagueRomarianInfo)
        }
      }
    }
  })

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  const filterData = (data) => {

    const fromDate = new Date(filterValidation.values.fromDate)
    const toDate = new Date(filterValidation.values.toDate)
    const curPage = filterValidation.values.curPage
    const limit = filterValidation.values.perPage
    
    let finalData = []

    console.log(fromDate, toDate)

    const _data = data
        .filter(i => {
          const modifiedDate = new Date(i.dateModified);
          const flag = modifiedDate >= fromDate && modifiedDate <= toDate;
          console.log(modifiedDate, flag)
          return flag;
        })
        .sort((a, b) => b.dateModified.localeCompare(a.dateModified))
    
    if (_data.length > 0) {
      const startIndex = Math.max(limit * (curPage - 1), 0)
      const endIndex = Math.min(limit * curPage, _data.length)
      const totalPage = Math.ceil(_data.length / limit)
  
      finalData = _data.slice(startIndex, endIndex)

      setData(finalData)
      setTotalPage(totalPage)
      setNoticeStr("")

      console.log(startIndex, endIndex, totalPage, _data, finalData)
    } else {
      setData([])
      setTotalPage(1)
      setNoticeStr("Data for selected filter not available")
    }
  }

  useEffect(() => {
    if (filterValidation.values.ftp == "Madrid" && data.length == 0 && madridRomarianInfo?.length > 0) {
      console.log("filter new data madrid")
      filterData(madridRomarianInfo)
    } else {
      console.log("madridRomarianInfo changed but no filter")
    }
  }, [madridRomarianInfo])

  useEffect(() => {
    if (filterValidation.values.ftp == "Hague" && data.length == 0 && hagueRomarianInfo?.length > 0) {
      console.log("filter new data hague")
      filterData(hagueRomarianInfo)
    } else {
      console.log("hagueRomarianInfo changed but no filter")
    }
  }, [hagueRomarianInfo])

  return (
    <TabPane style={activeTab === tabId ? { display: "block" } : { display: "none" }} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">

                <Row className="mb-3">
                  <label
                    className="col-md-1 col-form-label"
                  >
                    FTP
                  </label>
                  <div
                    className="col-md-2 form-check"
                    style={{ paddingLeft: "2em", paddingTop: '8px' }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="ftp"
                      id="ftpMadrid"
                      value="Madrid"
                      onChange={filterValidation.handleChange}
                      checked={
                        filterValidation.values.ftp === "Madrid"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="ftpMadrid"
                    >
                      Madrid
                    </label>
                  </div>

                  <div
                    className="col-md-2 form-check"
                    style={{ paddingLeft: "2em", paddingTop: '8px' }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="ftp"
                      id="ftpHague"
                      value="Hague"
                      onChange={filterValidation.handleChange}
                      checked={
                        filterValidation.values.ftp === "Hague"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="ftpHague"
                    >
                      Hague
                    </label>
                  </div>
                </Row>
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-11">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(data) && data.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0" style={{ width: "800px" }}>
                    <thead>
                      <tr>
                        <th>Date modified</th>
                        <th>Time</th>
                        <th>File name</th>
                        <th>File size</th>
                        <th>File type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        data.map((info, index) => {
                          return (
                            <tr key={info.fileName}>
                              <td>{info.dateModified}</td>
                              <td>{info.timeModified}</td>
                              <td>{info.fileName}</td>
                              <td>{info.fileSize}</td>
                              <td>{info.type}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => {
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default RomarianDbInfo;